import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ReportCard({ report, evaluations, role, company, onRestart }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const getScoreColor = (score) => {
        if (score >= 8) return '#10b981';
        if (score >= 6) return '#f59e0b';
        return '#ef4444';
    };

    const getGradeColor = (grade) => {
        if (grade === 'A') return '#10b981';
        if (grade === 'B') return '#3b82f6';
        if (grade === 'C') return '#f59e0b';
        return '#ef4444';
    };

    return (
        <>
            <div className="card report-header-card">
                <div className="report-score-section">
                    <div
                        className="report-grade"
                        style={{ color: getGradeColor(report.grade) }}
                    >
                        {report.grade}
                    </div>
                    <div className="report-score-info">
                        <h2>{report.overall_score}/10 {t('interview.overall_score')}</h2>
                        <p className="recommendation-badge">{report.recommendation}</p>
                        <p style={{ color: 'rgba(255,255,255,0.8)', marginTop: '0.5rem' }}>
                            {report.summary}
                        </p>
                    </div>
                </div>

                <div className="report-highlights">
                    {report.strongest_area && (
                        <div className="report-highlight good">
                            <strong>{t('interview.strongest_area')}:</strong>
                            <p>{report.strongest_area}</p>
                        </div>
                    )}
                    {report.improvement_area && (
                        <div className="report-highlight improve">
                            <strong>{t('interview.focus_improving')}:</strong>
                            <p>{report.improvement_area}</p>
                        </div>
                    )}
                </div>
            </div>

            <div className="section">
                <h2>{t('interview.question_breakdown')}</h2>
                {evaluations.map((ev, i) => (
                    <div key={i} className="card breakdown-card">
                        <div className="breakdown-header">
                            <div>
                                <span className={`type-badge type-${ev.question_type}`}>
                                    {ev.question_type === 'technical' ? t('interview.technical') : t('interview.behavioral')}
                                </span>
                                <p className="breakdown-question">{ev.question}</p>
                            </div>
                            <div
                                className="breakdown-score"
                                style={{ color: getScoreColor(ev.score) }}
                            >
                                {ev.score}/10
                            </div>
                        </div>
                        <div className="breakdown-answer">
                            <strong>{t('interview.your_answer')}:</strong>
                            <p>{ev.answer}</p>
                        </div>
                        <p className="breakdown-feedback">{ev.feedback}</p>
                    </div>
                ))}
            </div>

            <div className="report-actions">
                <button onClick={onRestart} className="btn-primary">
                    {t('interview.practice_again')}
                </button>
                <button
                    onClick={() => navigate('/career')}
                    className="btn-secondary"
                >
                    {t('interview.back_to_career')}
                </button>
            </div>
        </>
    );
}

export default ReportCard;